module.exports = __webpack_public_path__ + "static/nadejeLogo-ce7e343e85d24cadc4d9fe12323f062c.png";